import React, { FC } from 'react';
import { Tooltip, Checkbox } from '@material-ui/core';
import {
  BlockUserVariables,
  BlockUser,
} from '../../../graphql/user/types/BlockUser';
import { BLOCK_USER } from '../../../graphql/user/mutation';
import { displaySnackBar } from '../../../common/displaySnackbar';
import { useApolloClient, useMutation } from '@apollo/react-hooks';

interface Params {
  id: number;
  blocked: boolean;
  name: string;
  disabled: boolean;
}

const BlockUserCheckbox: FC<Params> = (props) => {
  const { id, blocked, name, disabled } = props;

  const client = useApolloClient();

  const [blockUser] = useMutation<BlockUser, BlockUserVariables>(BLOCK_USER, {
    onCompleted: (data) => {
      if (data && data.blockUser) {
        const blockedResult = data.blockUser.blocked;
        displaySnackBar(client, {
          type: 'SUCCESS',
          isOpen: true,
          message:
            blockedResult === true
              ? `${name} bloqué avec succès`
              : `${name} débloqué avec succès`,
        });
      }
    },
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    blockUser({
      variables: {
        id,
        blocked: event.target.checked,
      },
    });
  };

  return (
    <Tooltip {...{ title: `Bloquer ou débloquer ${name}` }}>
      <Checkbox checked={blocked} onChange={handleChange} disabled={disabled} />
    </Tooltip>
  );
};

export default BlockUserCheckbox;
